module.exports = __webpack_public_path__ + "static/media/pumpkin-choc-chip-muffins-in-pan.73b5938b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/pumpkin-choc-chip-muffins-in-pan.jpg
// module id = 401
// module chunks = 0